<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <form-item-group
      title="Carousels"
      :min="CONSTANT.CREATIVE_DEFAULT_VALUE.CAROUSEL.MIN_NUM"
      :max="CONSTANT.CREATIVE_DEFAULT_VALUE.CAROUSEL.MAX_NUM"
      :group-item="CONSTANT.CREATIVE_DEFAULT_VALUE.CAROUSEL.ITEM"
      v-model="item.carousels"
    >
      <template slot-scope="{ index }">
        <el-form-item
          label="Image"
          :prop="`carousels.${index}.image_url`"
          :rules="[
            ...imageSizeRule(limited_size.image),
            ...urlRule('image_url'),
          ]"
          label-width="120px"
        >
          <file-input
            accept="image/jpeg, image/png, image/gif"
            v-model="item.carousels[index].image_url"
            :check_upload_image_size="{
              ...limited_size.image,
              enable: true,
            }"
          ></file-input>
        </el-form-item>
        <el-form-item
          label="Landing Page"
          :prop="`carousels.${index}.landing_page`"
          :rules="urlRule('landing_page')"
          label-width="120px"
        >
          <el-input v-model="item.carousels[index].landing_page"></el-input>
        </el-form-item>
      </template>
    </form-item-group>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";
const { CAROUSEL } = CONSTANT.CREATIVE_DEFAULT_VALUE;
export default {
  data() {
    return {
      item: {
        carousels: [...Array(CAROUSEL.MIN_NUM)].map(() =>
          _.cloneDeep(CAROUSEL.ITEM)
        ),
      },
      limited_size: {
        image: {
          width: {
            max: 350,
            min: 350,
          },
          height: {
            max: 250,
            min: 250,
          },
        },
      },
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    setData(row) {
      this.item.carousels = _.map(row.carousels, (carousel) => {
        return {
          image_url: decodeURI(carousel.image_url),
          landing_page: decodeURI(carousel.landing_page),
        };
      });
    },
    async getData(setObj) {
      setObj.carousels = _.map(this.item.carousels, (carousel) => {
        return {
          image_url: carousel.image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
          landing_page: carousel.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
        };
      });
      return setObj;
    },
  },
};
</script>

<style></style>
